<template>
	<div class="container-fluid">
		<div class="alert alert-danger m-1" v-show="errors != null">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-12 col-sm-12 col-md-3 text-center h5" v-for="(item,index) in errors">
					{{item}}
				</div>
			</div>
		</div>
		<div class="row d-flex justify-content-center align-items-center mt-2">
			<div class="col-12">
				<div class="row d-flex justify-content-center align-items-center">	
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield">
					    	<input type="text" v-model="type.nev">
					    	<label>Név</label>
					  	</div>
					</div>
				</div>
				<div class="row d-flex justify-content-center">
					<div class="col-10">
						<div class="mui-textfield">
						    <textarea v-model="type.megjegyzes"></textarea>
						    <label>Megjegyzés</label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="m-2">
			<div class="row d-flex justify-content-center">
				<dir class="col text-center">
					<button class="btn btn-success btn-lg" @click.prevent="save">
						<span v-show="change">Mentés</span>
						<span v-show="!change">Hozzáad</span>
					</button>
				</dir>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'type_data',
	props:['change','id'],
	data() {
		return {
			type: {},
			errors: null
	    }
	},
	mounted(){
	    if(this.change) {
	    	this.$Progress.start()
	    	this.req.post('/types/getdata',{
	    		id: this.id
	    	})
	    		.then(res => {
	    			this.type = res.data.type
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			console.log(err)
	    			this.$Progress.fail()
	    		})
	    }
	},
	methods: {
		save(){
			this.$Progress.start()
			this.errors = null
	    	this.req.post('/types/save',{
	    		type: this.type,
	    		change: this.change
	    	})
	    		.then(res => {
	    			if(res.data.status === `error`) {
	    				this.errors = res.data.errors
	    			} else {
	    				toastr.success(`${this.change?'Mentés':'Hozzáadás'} sikeres`)
	    			}
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			this.$Progress.fail()
	    		})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/types/type_data.vue